import React, { useState } from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Personalized Customer Interactions",
    content:
      "Dynamic IVR solutions enable personalized experiences for each caller by integrating customer data from your CRM. This ensures that customers are greeted with relevant options, improving satisfaction and efficiency.",
  },
  {
    title: "Seamless CRM Integration",
    content:
      "Our IVR solution integrates seamlessly with any CRM system, allowing you to access customer details and history in real-time, providing a more tailored and professional experience for every call.",
  },
  {
    title: "Intelligent Call Routing",
    content:
      "Ensure that every call reaches the right agent or department using intelligent call routing based on customer input, priority levels, or business requirements, significantly reducing response times.",
  },
  {
    title: "Enhanced Operational Efficiency",
    content:
      "By automating repetitive tasks and providing multi-level menus, dynamic IVR solutions streamline call management, reduce operational overhead, and ensure that customers receive prompt and accurate assistance.",
  },
];

const IvrSolution = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (<>
    <Helmet>
      <meta name="description" content="Ayanshtech Solutions introduces innovative IVR solutions services to enhance customer communication, automate call handling, and boost business efficiency effortlessly."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Ayanshtech Solutions Introduces Innovative IVR solutions Services"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/dynamic-ivr-solution"/>
<meta property="og:description" content="Ayanshtech Solutions introduces innovative IVR solutions services to enhance customer communication, automate call handling, and boost business efficiency effortlessly."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Ayanshtech Solutions Introduces Innovative IVR solutions Services"/>
<meta name="twitter:description" content="Ayanshtech Solutions introduces innovative IVR solutions services to enhance customer communication, automate call handling, and boost business efficiency effortlessly."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/dynamic-ivr-solution"/>
<title>Ayanshtech Solutions Introduces Innovative IVR solutions Services</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center mt-10 mb-6 p-6">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start   mb-6">
        <div className="md:w-2/3 space-y-6 p-4">
          <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mt-10">
            Innovative IVR Solutions that Enhance Customer Interactions
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            Ayanshtech’s tailored IVR solutions have empowered businesses to
            gain a distinct advantage. Our IVR software development plays a key
            role in creating automated calling systems. Ayanshtech is equipped
            to build dynamic IVR frameworks that cater to the unique needs of
            our clients. With our advanced IVR development, we deliver an
            exceptional calling experience that enhances customer satisfaction.
            The integration of intelligent call routing within the IVR system
            elevates the customer journey. Moreover, our solution enables the
            creation of multiple sophisticated multi-level IVR menus.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            Key features such as support for DID numbers, trunk and queue
            management, agent handling, job scheduling, questionnaire
            management, and customer lead tracking ensure a customized IVR
            experience that’s seamless and efficient.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className=" rounded-3xl ">
        <div className="text-center mb-5 mt-5">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Interactive Voice Response (IVR) Systems
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Optimize call routing with our innovative, scalable multi-response
            menu builder designed to improve efficiency.
          </p>
        </div>

        <div className=" p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Language IVR Support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Efficiently handle large call volumes</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Future Scheduling, Snoozing, Voicemail Recording
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Builds multi-level IVR systems</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">DID number support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Drag-and-drop interface</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Reduced wait time for customers</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Support for multiple server connectivity
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Interactive customer feedback reports</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Recorded messages and scripts</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Efficient agent routing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Track and report customer complaints</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Prompt management</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Speed up customer service response time</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Different time zone support</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Reduced operational costs</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Essential Components of a Flexible IVR System
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Evolve with market dynamics and customer expectations using our
          adaptable IVR systems.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 p-4">
            <img
              src="/assets/images/headerSection/ivr.jpg"
              alt="IVR Solutions Services"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className=" md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Track and report customer complaints/grievance
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Enable hassle-free agent routing</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Reduced wait time</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon20.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Efficiently handle huge call volumes</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Speed up customer service</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Interactive customer feedback reports</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Reduce overhead cost</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-4 mb-6">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Innovative IVR Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
          Ayanshtech delivers advanced IVR solutions that combine exceptional
          design with flawless user experience. We specialize in various IVR
          systems, including self-service IVR, Hosted IVR, Agent-assisted IVR,
          and more. Our unique solutions are shaped by multiple touchpoints that
          set Ayanshtech apart.
        </p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-7xl mx-auto mb-20 p-4">
        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon2.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Enhance first-call resolution with a perfectly designed IVR menu.
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon3.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Provide seamless service even in the absence of customer
              representatives, boosting customer confidence in your brand.
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon4.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Collect valuable feedback to refine and optimize your IVR menus.
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon5.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Automate customer care operations, minimizing the need for manual
              intervention.
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon6.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Keep your system secure by hiding topology and carrier
              information.
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\techIcons\icon7.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Deliver a personalized experience that ensures customer
              satisfaction.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-4 mb-20 rounded-3xl">
        <h2 className="text-center sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-6">
          Dynamic IVR Solution Tailored for Your Business
        </h2>
        <p className="text-center text-lg text-gray-700 mb-8">
          Our advanced Dynamic IVR Solution empowers businesses to deliver
          personalized and efficient customer interactions. Seamlessly integrate
          with your CRM to provide a fully customizable and adaptive IVR system
          that caters to customer needs in real-time. With multi-level menus,
          intelligent routing, and automation, enhance customer satisfaction and
          reduce wait times, ensuring a seamless and professional communication
          experience.
        </p>

        <div className="flex flex-wrap justify-center gap-8 mb-4">
          {pointsData.map((point, index) => (
            <button
              key={index}
              className={`text-lg font-medium ${
                activeIndex === index
                  ? "text-blue-600 underline"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {point.title}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
          <p className="text-lg text-gray-600 mt-4">
            {pointsData[activeIndex].content}
          </p>
        </div>
      </div>

      <div className="text-center mb-10   ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Why choose for Ayanshtech as Your IVR Solution Provider
        </h2>
        <p className="sm:text-base md:text-lg lg:text-lg text-gray-600 mt-4 max-w-6xl mx-auto">
          IVR systems serve as the initial point of contact when reaching a
          contact center. The IVR solution installed at the center welcomes
          customers and offers various options. With Ayanshtech's powerful,
          tailored IVR solutions, you can efficiently manage high call volumes.
          During peak hours when waiting in a queue is inevitable, the
          interactive voice response system enables quick navigation through
          available choices. Ayanshtech's smart, on-demand IVR solutions come
          with rapid setup, affordable pricing, real-time analytics, CRM
          integration, a user-friendly dashboard, and much more.
        </p>
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default IvrSolution;
